import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

type LightTooltipProps = TooltipProps & {
  /** Show tooltip on first render (uncontrolled). Ignored if `open` is provided */
  defaultOpen?: boolean;
};

export const LightTooltip = styled(
  ({
    className,
    children,
    open: openProp,
    onOpen,
    onClose,
    defaultOpen = false,
    placement = 'right',
    ...props
  }: LightTooltipProps) => {
    const controlled = openProp !== undefined;
    const [open, setOpen] = React.useState(defaultOpen);
    const tooltipRef = React.useRef<HTMLSpanElement | null>(null);
    const isOpen = controlled ? openProp : open;

    const handleOpen = (e: unknown) => {
      onOpen?.(e as any);
      if (!controlled) setOpen(true);
    };

    const handleClose = (e?: unknown) => {
      onClose?.(e as any);
      if (!controlled) setOpen(false);
    };

    React.useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          tooltipRef.current &&
          !tooltipRef.current.contains(event.target as Node)
        ) {
          handleClose();
        }
      };

      if (isOpen) {
        document.addEventListener('mousedown', handleClickOutside);
      } else {
        document.removeEventListener('mousedown', handleClickOutside);
      }

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isOpen]);

    return (
      <Tooltip
        {...props}
        // arrow
        placement={placement}
        open={isOpen}
        classes={{ popper: className }}
        slotProps={{ popper: { sx: { zIndex: 999999999 } } }}
        onOpen={handleOpen}
        onClose={handleClose}
      >
        <span
          ref={tooltipRef}
          onMouseEnter={handleOpen}
          onFocus={handleOpen}
          style={{ display: 'inline-flex' }}
        >
          {children}
        </span>
      </Tooltip>
    );
  }
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: '#595959',
    // boxShadow: '0 1px 0 0 rgba(0, 0, 0, 0.16)',
    fontSize: 14,
    borderRadius: 6,
    fontFamily: 'SEGOE-UI-VF',
    padding: 0,
    margin: '4px 0 !important',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#BFBFBF',
  },
}));
